export default __webpack_public_path__ + "static/vlc-1f6d2bbb75bf75a53467daed7b352494.png";